/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Tenant } from '../../../interfaces/masters/tenant';

@Injectable()
export class TenantApi {
  private readonly apiController: string = 'tenants/';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(this.apiController+url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }
  validateCustomerByHostName(url: string, options?: any): Observable<any[]> {
    var hostName=window.location.host;
    
    let queryParams = new HttpParams()
      .set('sourceUrl', hostName.toString());
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
  }

  

  getById(url : string, options?: any): Observable<Tenant> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }
  getCustomerId(url : string, options?: any): Observable<Tenant> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: Tenant):Observable<Tenant>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost( url, data, header);
  }
  addAccount(url:string, data: any):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost( url, data, header);
  }
  search(url:string, data: any):Observable<Tenant>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost( url, data, header);
  }
  update(url:string, data: Tenant):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
}
}
